
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { A } from "@solidjs/router";
import { useCalendarState } from "@state/events/calendar-state";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import { For, Show } from "solid-js";
import { useService } from "solid-services";
import { css } from "styled-system/css";
import { Flex, Grid } from "styled-system/jsx";

dayjs.extend(relativeTime)

export default function () {
  const { upcomingEvents, setActiveEvent } = useService(useCalendarState)();

  return (
    <Grid gap={0}>
      <For each={upcomingEvents()}>
        {(event, index) => (
          <Flex justifyContent='space-between' alignContent='center' p={3} gap='3' class={css({
            '& + &': {
              borderTop: 'solid 1px',
              borderColor: 'bg.subtle'
            }
          })}>

            <Flex justifyContent='space-between' alignItems='center' gap={1}>
              <Text fontSize='sm'>{event.group}</Text>
              <Show when={index() === 0}>
                <Badge size='sm' colorPalette='jade' variant='solid'>Next</Badge>
              </Show>
            </Flex>
            <Flex justifyContent='space-between' alignItems='center' gap={1}>
              <Text fontSize='xs'>{event.localTime.fromNow()}</Text>
              <A href='/events'>
                <Button variant="outline" size="2xs" onClick={() => setActiveEvent(event)}>
                  Join
                </Button>
              </A>
            </Flex>
          </Flex>
        )}
      </For>
    </Grid>
  )
}
